import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { HdContentLanguageService } from '@/app/human-design/chart/bodygraph/hd-content-language.service';
import { HdTransitsPanelComponent } from '@/app/human-design/transits/transits-panel/hd-transits-panel.component';
import { EgiPageNavigationService } from '@/app/platform/platform-context/egi-page-navigation.service';
import { ViewportService } from '@core/services/viewport.service';
import { HD_CHART_ENVIRONMENT_PAGE_ID } from '../chart.pages/hd-page-ids';

/**
 * Transits-pagina (spec §4 Plaatsing, besluit 2): dunne route
 * `/human-design/transits` die de transits-container (verticale dag-tijdlijn
 * of Nu & Straks + ephemeris-lanes) paginavullend toont. Werkt zonder geladen
 * chart (globale modus, besluit 14). Een vanuit de transits bewaard moment
 * opent in de chart-omgeving.
 */
@Component({
  selector: 'hd-transits-page',
  standalone: true,
  imports: [SharedModule, HdTransitsPanelComponent],
  templateUrl: './hd-transits-page.component.html',
  styleUrl: './hd-transits-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdTransitsPageComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);
  private readonly egiPageNavigation = inject(EgiPageNavigationService);
  /** Phone: dezelfde compacte weergave als het transits-paneel in de chart-omgeving. */
  protected readonly viewport = inject(ViewportService);

  protected readonly title = computed(() => {
    this.contentLang.translationsLoadedTick();
    return this.transloco.translate<string>(
      'humanDesign.chart.transits.lanes.title',
      undefined,
      this.contentLang.effectiveLang(),
    );
  });

  /** Bewaard moment openen: de chart-omgeving laadt het in een nieuwe tab. */
  protected openChart(chartId: string): void {
    this.egiPageNavigation.navigateToPage(HD_CHART_ENVIRONMENT_PAGE_ID, { loadChartId: chartId });
  }

  /** Just Now (transit) bij de nu-lijn: de chart-omgeving opent hem in een nieuwe tab. */
  protected openJustNow(): void {
    this.egiPageNavigation.navigateToPage(HD_CHART_ENVIRONMENT_PAGE_ID, { justNow: 'transit' });
  }

  /** Rave New Year-badge in de dag-flow: de chart-omgeving opent de transit-chart van dat jaar. */
  protected openRaveNewYear(year: number): void {
    this.egiPageNavigation.navigateToPage(HD_CHART_ENVIRONMENT_PAGE_ID, { raveNewYear: `${year}` });
  }
}
